import { get, post } from './common'

export namespace ppt {
  // 获取PPT分组列表
  export function getGroupList() {
    return get<ApiTypes.DataListResult<ServerData.PptGroupData[]>>('/group/list', {})
  }

  export function getSubGroupList(groupId: number) {
    return get<ApiTypes.DataListResult<ServerData.PptSubGroupData[]>>(`/sub/group/list`, {
      groupId,
    })
  }

  // 获取PPT列表
  export function getPptList(data: PostData.PPTListModal) {
    return post<ApiTypes.DataListResult<ServerData.PptData[]>>(`/material/list`, {}, data)
  }

  // 获取推荐PPT
  export function getPptRecommend(materialId: number) {
    return get<ApiTypes.DataListResult<ServerData.PptData[]>>(`/material/recommend`, {
      materialId,
    })
  }

  // 获取下载PPT
  export function getPptDownload(materialId: number) {
    return post<ApiTypes.DataResult<{ url: string }>>(`/material/download`, {}, { materialId })
  }

  // 获取PPT详情
  export function getPptInfo(materialId: number) {
    return get<ApiTypes.DataResult<ServerData.PptInfoData>>(`/material/info`, { materialId })
  }

  // 获取ppt素材下载记录
  export function getPptDownloadList() {
    return get<ApiTypes.DataListResult<ServerData.DownloadRecord>>(`/material/download/history`)
  }

}
